"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _dataCapsule = require("data-capsule");
var _workerStrategy = _interopRequireDefault(require("./workerStrategy.js"));
var _consts = require("./applications/consts.js");
var _utils = require("./utils/utils");
var _httpClient = require("@wix/http-client");
var _cartItemsStatuses = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/cartItemsStatuses"));
var _photographyClientLib = require("@wix/photography-client-lib");
var httpClient = new _httpClient.HttpClient();
var CartApi = /*#__PURE__*/function () {
  function CartApi(namespace, instance) {
    this.namespace = namespace;
    this.instance = instance;
    // if (utils.isDev()) {
    var strategy = new _workerStrategy["default"]();
    this.dataStorage = new _dataCapsule.DataCapsule({
      strategy: strategy,
      namespace: namespace
    });
  }
  var _proto = CartApi.prototype;
  _proto.addToCart = function addToCart(uuid, mediaUrl, galleryId, providerId, quantity, isDemo, metadata, styleId) {
    var _this = this;
    var newItem = {
      uuid: uuid,
      mediaUrl: mediaUrl,
      galleryId: galleryId,
      providerId: providerId,
      quantity: quantity,
      isDemo: isDemo,
      metadata: metadata,
      styleId: styleId,
      status: _cartItemsStatuses["default"].OK,
      timestamp: new Date().getTime()
    };
    return this.setItem(uuid, newItem).then(function () {
      _this.notifyCartChange();
      return Promise.resolve(newItem);
    });
  };
  _proto.updateItemsValidation = /*#__PURE__*/function () {
    var _updateItemsValidation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arrItems, url) {
      var isNonEmptyArray, uniqueIdsToCheck, invalidItems;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (url === void 0) {
              url = undefined;
            }
            isNonEmptyArray = this._isNonEmptyArray(arrItems);
            if (!isNonEmptyArray) {
              _context.next = 10;
              break;
            }
            uniqueIdsToCheck = this.getItemsUniqueIds(arrItems);
            if (!this._isNonEmptyArray(uniqueIdsToCheck)) {
              _context.next = 10;
              break;
            }
            _context.next = 7;
            return this.getInvalidItemsForDownload(url, uniqueIdsToCheck);
          case 7:
            invalidItems = _context.sent;
            this.setInvalidItemsForDownload(invalidItems, arrItems);
            return _context.abrupt("return", Promise.resolve());
          case 10:
            return _context.abrupt("return", Promise.reject("No ids to check for invalid cart items"));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function updateItemsValidation(_x, _x2) {
      return _updateItemsValidation.apply(this, arguments);
    }
    return updateItemsValidation;
  }();
  _proto.removeFromCart = function removeFromCart(uuid) {
    var _this2 = this;
    return this.dataStorage.removeItem(uuid).then(function () {
      _this2.notifyCartChange();
    });
  };
  _proto.notifyCartChange = function notifyCartChange() {
    if (_photographyClientLib.window.Wix) {
      _photographyClientLib.Wix.PubSub.publish(_consts.ARTSTORE_PUBSUB_ENUMS.REFRESH_CART, {}, true);
    }
  };
  _proto.clearCart = function clearCart() {
    var _this3 = this;
    if (_utils.utils.isStoreGallery()) {
      return this.getCartItems('*').then(function (arrItems) {
        var arrPromises = [];
        arrItems.forEach(function (item) {
          var uuid = item.uuid;
          arrPromises.push(_this3.dataStorage.removeItem(uuid));
        });
        return Promise.all(arrPromises);
      }).then(function () {
        _this3.notifyCartChange();
      });
    }
  };
  _proto.setItem = function setItem(uuid, item, expiration /* 24 hours */) {
    if (expiration === void 0) {
      expiration = 86400;
    }
    return this.dataStorage.setItem(uuid, item, {
      expiration: expiration
    });
  };
  _proto.updateCartItem = function updateCartItem(uuid, metadata, quantity) {
    var _this4 = this;
    return this.dataStorage.getItem(uuid).then(function (cartItem) {
      var returnPromise = null;
      if (cartItem) {
        cartItem.metadata = metadata || cartItem.metadata;
        cartItem.quantity = quantity || cartItem.quantity;
        returnPromise = _this4.setItem(uuid, cartItem).then(function () {
          _this4.notifyCartChange();
        });
      } else {
        returnPromise = Promise.reject('Item not found');
      }
      return returnPromise;
    });
  };
  _proto.getCartItemsCount = function getCartItemsCount(arrItems) {
    var count = arrItems.reduce(function (previousCount, cartItem) {
      return previousCount + cartItem.quantity;
    }, 0);
    return count;
  };
  _proto.getCartItems = function getCartItems(connectedProviderId, options) {
    if (options === void 0) {
      options = {};
    }
    if (!connectedProviderId) {
      var message = "Can't get cart items without providerId";
      console.error(message);
      throw message;
    }
    try {
      return this.dataStorage.getAllItems().then(function (objCartItems) {
        var cartItems = [];
        var itemUUID = options.uuid;
        // eslint-disable-next-line guard-for-in
        for (var cartItemUuid in objCartItems) {
          var cartItemCandidate = objCartItems[cartItemUuid];
          var uuid = cartItemCandidate.uuid,
            providerId = cartItemCandidate.providerId;
          var isUUIDValid = !itemUUID || itemUUID === uuid;
          var isSameProviderId = !connectedProviderId || connectedProviderId === providerId || connectedProviderId === '*';
          var shouldAddItem = isUUIDValid && isSameProviderId;
          if (shouldAddItem) {
            var cartItem = objCartItems[uuid];
            cartItems.push(cartItem);
          }
        }
        return cartItems.sort(function (item1, item2) {
          var item1Timestamp = item1.timestamp || 0;
          var item2Timestamp = item2.timestamp || 0;
          return item1Timestamp - item2Timestamp;
        });
      });
    } catch (error) {
      console.error('CartApi - getCartItems - ERROR:', error);
    }
  };
  _proto.containsDemoItems = function containsDemoItems(connectedProviderId) {
    return this.getCartItems(connectedProviderId).then(function (items) {
      return items.filter(function (item) {
        return item.isDemo;
      });
    }).then(function (demoItems) {
      return demoItems.length > 0;
    });
  };
  _proto.countCartForms = function countCartForms() {
    var cartFormCount = 0;
    for (var i = 0; i < _photographyClientLib.window.top.frames.length; i++) {
      var frame = _photographyClientLib.window.top.frames[i];
      try {
        if (frame.location.href.indexOf('cart-form') !== -1) {
          cartFormCount++;
        }
      } catch (e) {}
    }
    return cartFormCount;
  };
  _proto.createCartForm = function createCartForm() {
    if (_utils.utils.isStoreGallery()) {
      var cartFormCount = this.countCartForms();
      if (!cartFormCount) {
        if (_photographyClientLib.Wix.Utils.getViewMode() === 'site' || _photographyClientLib.Wix.Utils.getViewMode() === 'preview') {
          _photographyClientLib.Wix.openPersistentPopup({
            url: _photographyClientLib.window.location.origin + '/cart-form.html?isStore=true',
            width: '0%',
            height: '100%',
            position: {
              origin: _photographyClientLib.Wix.WindowOrigin.FIXED,
              placement: _photographyClientLib.Wix.WindowPlacement.CENTER
            },
            theme: _photographyClientLib.Wix.Theme.BARE
          });
        }
      }
    }
  };
  _proto.showCart = function showCart() {
    _photographyClientLib.Wix.PubSub.publish('showCart', {}, false);
    _photographyClientLib.Wix.PubSub.publish(_consts.ARTSTORE_PUBSUB_ENUMS.SHOW_OOI_CART, {}, false);
  };
  _proto.hideCart = function hideCart(data) {
    _photographyClientLib.Wix.PubSub.publish('closeCartForm', {
      data: data
    }, false);
  };
  _proto.publishAddToCart = function publishAddToCart(dataToSend) {
    _photographyClientLib.Wix.PubSub.publish('ADD_TO_CART', dataToSend, true);
  };
  _proto._isNonEmptyArray = function _isNonEmptyArray(arr) {
    return arr && Array.isArray(arr) && arr.length;
  };
  _proto._setInvalidItems = function _setInvalidItems(arrInvalidItems) {
    var _this5 = this;
    if (this._isNonEmptyArray(arrInvalidItems)) {
      var invalidPromises = [];
      arrInvalidItems.forEach(function (invalidItem) {
        var item = invalidItem.item,
          reason = invalidItem.reason;
        invalidPromises.push(_this5.setItem(item.uuid, Object.assign({}, item, {
          status: reason
        })));
      });
      return Promise.all(invalidPromises).then(function () {
        _this5.notifyCartChange();
      });
    }
  };
  _proto.getInvalidItemsForDownload = /*#__PURE__*/function () {
    var _getInvalidItemsForDownload = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(url, uniqueIdsToCheck) {
      var defaultUrl, _url, payload, response, invalidItems;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            defaultUrl = "_api/pro-gallery-webapp/v1/items/verification?instance=" + this.instance;
            _url = url || defaultUrl;
            payload = url ? {
              uniqueIdsToCheck: uniqueIdsToCheck
            } : {
              mediaUrls: uniqueIdsToCheck
            };
            if (!this._isNonEmptyArray(uniqueIdsToCheck)) {
              _context2.next = 9;
              break;
            }
            _context2.next = 6;
            return httpClient.post(_url, payload, {
              headers: {
                'content-type': 'application/json'
              }
            });
          case 6:
            response = _context2.sent;
            invalidItems = response.data.invalidItems;
            return _context2.abrupt("return", invalidItems);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getInvalidItemsForDownload(_x3, _x4) {
      return _getInvalidItemsForDownload.apply(this, arguments);
    }
    return getInvalidItemsForDownload;
  }();
  _proto.setInvalidItemsForDownload = function setInvalidItemsForDownload(invalidItems, items) {
    var _this6 = this;
    if (this._isNonEmptyArray(invalidItems)) {
      invalidItems.forEach(function (invalidItem) {
        var mediaUrl = invalidItem.mediaUrl,
          err = invalidItem.err;
        var arrInvalidCartItems = items.filter(function (cartItem) {
          return cartItem.mediaUrl === mediaUrl;
        });
        var result = [].concat(arrInvalidCartItems.map(function (item) {
          return {
            item: item,
            reason: err || _cartItemsStatuses["default"].INVALID
          };
        }));
        _this6._setInvalidItems(result);
      });
    }
  };
  _proto.getItemsUniqueIds = function getItemsUniqueIds(items) {
    return items.reduce(function (previousValue, currentValue) {
      var mediaUrl = currentValue.mediaUrl;
      if (mediaUrl && previousValue.indexOf(mediaUrl) === -1) {
        previousValue.push(mediaUrl);
      }
      return previousValue;
    }, []);
  };
  return CartApi;
}();
var domain = '';
var instance = _photographyClientLib.window.instance;
if (_photographyClientLib.window.instanceId) {
  domain = _photographyClientLib.window.instanceId;
} else {
  try {
    if (_photographyClientLib.window.Wix) {
      domain = _photographyClientLib.Wix.Utils.getInstanceId();
    } else {
      // We're in a test
      domain = 'test';
    }
  } catch (error) {
    console.log("error domain", error);
  }
}
var cartApi = new CartApi(domain, instance);
var _default = exports["default"] = cartApi;
if (process.env.NODE_ENV === 'development') {
  _photographyClientLib.window.galleryApi = _photographyClientLib.window.galleryApi || {};
  _photographyClientLib.window.galleryApi.cartApi = cartApi;
}